import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { resolveBreadcrumbs } from '../../app/routeMeta'

export default function Breadcrumbs() {
  const { pathname } = useLocation()
  const crumbs = resolveBreadcrumbs(pathname)

  if (!crumbs.length) return null

  return (
    <MuiBreadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ opacity: 0.6 }} />}
      sx={{ mb: 1.5, '& .MuiBreadcrumbs-li': { maxWidth: 280 } }}
    >
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1
        if (last || !c.to) {
          return (
            <Typography key={c.key} color="text.secondary" variant="body2" noWrap>
              {c.label}
            </Typography>
          )
        }
        return (
          <Link
            key={c.key}
            component={RouterLink}
            to={c.to}
            underline="hover"
            color="inherit"
            variant="body2"
            noWrap
          >
            {c.label}
          </Link>
        )
      })}
    </MuiBreadcrumbs>
  )
}
